import { CustomSelector } from "../../ui/components/CustomSelector";

export class AITemplateLanguage extends CustomSelector {
    init() {
        super.init();
        this.parentModal = this.element.closest(".modal");
        if (this.parentModal) {
            this.parentModal.addEventListener("hide.bs.modal", () => {
                this.closeOptions();
            });
        }
        this.syncLanguageFromActiveOption();
    }

    getMobileOptions() {
        const target = this.selectSelected?.element?.getAttribute?.(
            "data-bs-target"
        );
        const offcanvasElement = target ? document.querySelector(target) : null;
        return Array.from(
            offcanvasElement?.querySelectorAll?.(
                ".language-choice__custom-select__select-option"
            ) || []
        );
    }

    syncLanguageFromActiveOption() {
        const options = Array.from(this.selectOption || []);
        const activeOption =
            options.find((el) => el?.classList?.contains?.("active")) ||
            options[0];
        const language = activeOption?.dataset?.language;
        if (language && this.element?.dataset) {
            this.element.dataset.language = language;
        }
    }

    handleOptionSelect(e, optionComponent) {
        e.stopPropagation();
        const language = optionComponent?.dataset?.language;
        const text = optionComponent?.textContent?.trim?.() || "";

        if (this.selectedText?.element) {
            this.selectedText.element.textContent = text;
        }
        if (language && this.element?.dataset) {
            this.element.dataset.language = language;
        }

        const desktopOptions = Array.from(this.selectOption || []);
        const mobileOptions = this.getMobileOptions();

        desktopOptions.forEach((el) => el?.classList?.remove?.("active"));
        mobileOptions.forEach((el) => el?.classList?.remove?.("active"));

        let idx = desktopOptions.indexOf(optionComponent);
        if (idx === -1) idx = mobileOptions.indexOf(optionComponent);

        if (idx !== -1) {
            desktopOptions[idx]?.classList?.add?.("active");
            mobileOptions[idx]?.classList?.add?.("active");
        } else {
            optionComponent?.classList?.add?.("active");
        }

        this.selectOptions?.addClass?.("d-none");
    }

    handleMobileOptionSelect(e, optionComponent) {
        this.handleOptionSelect(e, optionComponent);
    }
}

